<template>
  <div class="enrollment_footer">
    <div class="vcore_container">
      <div class="vcore_row">
        <div class="vcore_col--xs--12 vcore_col--lg--2">
          <!-- Use computed to calculate logo to use -->
          <img
            class="enrollment_footer_logo"
            src="@Shared/assets/images/cb-logo-green.svg"
            alt="Commerce Bank Logo"
          />
          <img
            class="vcore_hidden--lg--up"
            id="ehlLogoMobile"
            src="@Shared/assets/images/EHLLogo.svg"
          />
        </div>
        <div class="vcore_col--xs--12 vcore_col--lg--4">
          <div class="copyrightFooter">
            <p>
              Copyright {{ new Date().getFullYear() }} Commerce Bancshares Inc.
              <br />All rights reserved. Commerce Bank Member FDIC.
            </p>
          </div>
        </div>
        <div class="vcore_col--xs--12 vcore_col--lg--6">
          <div class="enrollment_footer_help-links">
            <div class="footerLinks">
              <a
                class="enrollment_footer_help-link vcore_link"
                target="_blank"
                href="https://www.commercebank.com/about-us/accessibility"
                alt="Website Accessibility"
                >Website Accessibility</a
              >
              <a
                class="enrollment_footer_help-link vcore_link"
                target="_blank"
                href="https://www.commercebank.com/security-center/privacy-statement"
                alt="Privacy Statement"
                >Privacy Statement</a
              >
              <br />
              <a
                class="enrollment_footer_help-link vcore_link"
                target="_blank"
                href="https://www.commercebank.com/online-privacy-policy"
                alt="Privacy Policy & Terms of Service"
                >Online Privacy Policy & Terms of Service</a
              >
            </div>
            <div id="EHLLogo" class="vcore_hidden--md--down">
              <img
                alt="Equal Housing Lender"
                src="@Shared/assets/images/EHLLogo.svg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "LandingPageFooter",
  computed: {
    copyrightYear() {
      return moment().format("YYYY");
    },
    ...mapGetters(["featureFlags"]),
  },
};
</script>
<style lang="scss" scoped>
.copyrightFooter {
  padding: 16px 0px;

  @media (max-width: $grid-breakpoint-md) {
    padding-top: 0px;
  }

  p {
    font-size: 14px;
  }
}

#EHLLogo {
  padding-left: 14px;
}

#ehlLogoMobile {
  @media (max-width: $grid-breakpoint-md) {
    margin-left: 116px;
    margin-bottom: 14px;
  }
  @media (max-width: $grid-breakpoint-sm) {
    float: right;
    margin: 18px;
  }
  @media (max-width: $grid-breakpoint-lg) and (orientation: landscape) {
    padding: 0px 0px 15px 100px;
  }
}

.enrollment_footer {
  width: 100%;
  background-color: $color_gray-6;
  overflow: hidden;
  position: relative;
  bottom: 0;

  @media (max-width: $grid-breakpoint-lg) {
    padding-left: 20px;
  }

  @media (max-width: $grid-breakpoint-sm) {
    padding-left: 15px;
  }

  .enrollment_footer_logo {
    width: 130px;
    height: 100%;
    padding: 26px 0;
  }

  .enrollment_footer_help-links {
    text-align: right;
    line-height: 20px;
    padding: 16px 0;
    display: inline-flex;
    float: right;

    @media (max-width: $grid-breakpoint-lg) {
      text-align: left;

      @media (orientation: landscape) {
        float: initial;
      }
    }

    @media (max-width: $grid-breakpoint-md) {
      padding: 0px;
      float: none;
    }

    .enrollment_footer_help-link {
      background: none;
      border: none;
      font-size: 14px;
      font-weight: bold;
      color: $color_gray-2;
      text-decoration: underline;
      cursor: pointer;
      padding: 0;
      margin-right: 15px;

      @media (max-width: $grid-breakpoint-lg) {
        display: block;
      }

      & + .enrollment_footer_help-link {
        @media (max-width: $grid-breakpoint-lg) {
          margin-left: 0;
          margin-top: 15px;
        }
      }
    }
  }
}
</style>
